"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TERTIARY_XSMALL_BUTTON_PADDING = exports.TERTIARY_SMALL_BUTTON_PADDING = exports.TERTIARY_MEDIUM_BUTTON_PADDING = exports.TERTIARY_LARGE_BUTTON_PADDING = exports.XSMALL_BUTTON_PADDING = exports.SMALL_BUTTON_PADDING = exports.MEDIUM_BUTTON_PADDING = exports.LARGE_BUTTON_PADDING = exports.XSMALL_BUTTON_HEIGHT = exports.SMALL_BUTTON_HEIGHT = exports.MEDIUM_BUTTON_HEIGHT = exports.LARGE_BUTTON_HEIGHT = void 0;
exports.LARGE_BUTTON_HEIGHT = '4rem';
exports.MEDIUM_BUTTON_HEIGHT = '3.25rem';
exports.SMALL_BUTTON_HEIGHT = '2.5rem';
exports.XSMALL_BUTTON_HEIGHT = '2rem';
exports.LARGE_BUTTON_PADDING = '1.375rem 1.75rem';
exports.MEDIUM_BUTTON_PADDING = '1rem 1.5rem';
exports.SMALL_BUTTON_PADDING = '0.625rem 1.25rem';
exports.XSMALL_BUTTON_PADDING = '0.375rem 1rem';
exports.TERTIARY_LARGE_BUTTON_PADDING = '1.375rem 0.5rem';
exports.TERTIARY_MEDIUM_BUTTON_PADDING = '1rem 0.5rem';
exports.TERTIARY_SMALL_BUTTON_PADDING = '0.625rem 0.5rem';
exports.TERTIARY_XSMALL_BUTTON_PADDING = '0.375rem 0.5rem';
